import React from 'react';
import './App.css';
import Header from './Header';
import Sidebar from './Sidebar';
import Feed from './Feed'; 
import Widgets from './Widgets';
import {useSelector} from 'react-redux';
import { login, logout, selectUser } from './features/userSlice';
import Login from './Login';
import { useEffect } from 'react';
import {auth} from './firebase';
import { useDispatch } from 'react-redux';

function App() {

  const user = useSelector(selectUser);
  const dispatch = useDispatch();

  useEffect(() => {
    auth.onAuthStateChanged(userAuth => {
      
      if(userAuth){
        dispatch(login({
          email: userAuth.email,
          uid: userAuth.uid,
          name: userAuth.displayName,
          photoUrl: userAuth.photoURL,
        }))

      }else{
        dispatch(logout());
      }
    })

  }, []);

  return (
    <div className='app'>
      <Header/>

      {!user ? (
        <Login />
      ):(
        <div className='app__body'>
          <Sidebar />
          <Feed />
          <Widgets />
        </div>
      )}
    </div>
  );
}

export default App;
